import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { formatApiErrorDetail } from "../lib/api_errore"

// AnalyzeModal di components/AnalyzeModal.js:61-117 (31a5bd1). All'evento "pagina-progetto:analizza" su window la
// finestra si apre nell'attesa (passo 0), un passo finto ogni 900 ms fino all'ultimo; POST /app/progetto/:id/analizza
// (POST /projects/:id/analyze). Riuscita, legge lo stato del lavoro come pollAnalysisJob (GET
// /api/projects/:id/analysis-status ogni 3 s, al più 80 volte): «done» carica il risultato nel turbo-frame
// "analisi-risultato" (letto dal server con la scheda di oggi) e rilegge la pagina (onComplete → load()); «error» o il
// tempo scaduto danno «L'analisi AI non è andata a buon fine. Riprova tra poco.». Una POST rifiutata: il dettaglio
// della risposta. In entrambi gli errori il toast «Analisi non riuscita». Chiudere la finestra ferma passi e letture.
//
// La rilettura della pagina è un refresh con morph che tiene lo scroll (Turbo.session.refresh): la finestra è
// permanente; i frame con refresh="morph" (passo 4, passo 3) si rileggono; lo stato aperto/chiuso dei riquadri e dei
// «Mostra» lo tiene riquadro_controller.js (turbo:before-morph-attribute), come lo stato di React dopo load().
const PASSO_MS = 900
const INTERVALLO = 3000
const TENTATIVI = 80
const ERRORE_LAVORO = "L'analisi AI non è andata a buon fine. Riprova tra poco."

export default class extends Controller {
  static targets = ["attesa", "errore", "messaggio", "risultato", "passo"]
  static values = { avvio: String, stato: String, risultato: String }

  disconnect() {
    this.ferma()
  }

  async apri() {
    this.ferma()
    const giro = (this.giro = {})
    this.fase("attesa")
    this.risultatoTarget.removeAttribute("src")
    this.risultatoTarget.innerHTML = ""
    this.passo = 0
    this.segnaPassi()
    this.ticker = setInterval(() => {
      if (this.passo < this.passoTargets.length - 1) this.passo += 1
      this.segnaPassi()
    }, PASSO_MS)
    window.dispatchEvent(new CustomEvent("dialog:open", { detail: { id: this.element.id } }))

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const res = await fetch(this.avvioValue, {
        method: "POST", credentials: "same-origin",
        headers: { Accept: "application/json", ...(token ? { "X-CSRF-Token": token } : {}) },
      })
      if (giro !== this.giro) return
      if (!res.ok) {
        let data
        try { data = await res.json() } catch { data = undefined }
        if (giro !== this.giro) return
        return this.errore(data?.detail !== undefined ? formatApiErrorDetail(data.detail) : `HTTP ${res.status}`)
      }
    } catch (err) {
      if (giro === this.giro) this.errore(err.message)
      return
    }
    this.leggi(giro, 0)
  }

  leggi(giro, tentativi) {
    this.timer = setTimeout(async () => {
      if (giro !== this.giro) return
      tentativi += 1
      try {
        const res = await fetch(this.statoValue, { headers: { Accept: "application/json" }, credentials: "same-origin" })
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        const data = await res.json()
        if (giro !== this.giro) return
        if (data.status === "done") return this.fatto()
        if (data.status === "error") return this.errore(ERRORE_LAVORO)
      } catch {
        // errore transitorio di rete o del proxy: si continua fino ai tentativi massimi
      }
      if (giro !== this.giro) return
      if (tentativi >= TENTATIVI) return this.errore(ERRORE_LAVORO)
      this.leggi(giro, tentativi)
    }, INTERVALLO)
  }

  fatto() {
    clearInterval(this.ticker)
    this.fase("risultato")
    this.risultatoTarget.src = this.risultatoValue
    this.ricaricaPagina()
  }

  errore(testo) {
    clearInterval(this.ticker)
    this.messaggioTarget.textContent = testo
    this.fase("errore")
    window.toast?.error("Analisi non riuscita")
  }

  // la finestra chiusa (dialog:closed): nessun passo e nessuna lettura dopo
  chiusa() {
    this.ferma()
  }

  ferma() {
    this.giro = null
    clearInterval(this.ticker)
    clearTimeout(this.timer)
  }

  fase(nome) {
    this.attesaTarget.hidden = nome !== "attesa"
    this.erroreTarget.hidden = nome !== "errore"
    this.risultatoTarget.hidden = nome !== "risultato"
  }

  segnaPassi() {
    this.passoTargets.forEach((el, i) => {
      el.classList.toggle("opacity-100", i <= this.passo)
      el.classList.toggle("opacity-30", i > this.passo)
      el.querySelector('[data-segno="fatto"]').toggleAttribute("hidden", !(i < this.passo))
      el.querySelector('[data-segno="ora"]').toggleAttribute("hidden", i !== this.passo)
      el.querySelector('[data-segno="dopo"]').toggleAttribute("hidden", !(i > this.passo))
    })
  }

  // onComplete → load(): la pagina riletta con morph, scroll tenuto
  ricaricaPagina() {
    Turbo.session.refresh(document.baseURI, { method: "morph", scroll: "preserve" })
  }
}
